import React from 'react'
import formatMessage from 'format-message'
import { CheckSVG, DeleteSVG } from '../comments/CommentButtons'

export default function Tooltip({
  authorName,
  canDelete,
  canEdit,
  displayAuthorName,
  displayCreateAnnotation = false,
  onCreateAnnotation = () => {},
  onDeleteAnnotation,
  isSavedFromSession,
}) {
  const stopPropagation = (event) => event.stopPropagation()

  const handleAnnotationSave = (event) => {
    event.stopPropagation()
    if (typeof onCreateAnnotation === 'function') {
      onCreateAnnotation(event)
    }
  }

  const handleAnnotationDelete = (event) => onDeleteAnnotation(event)

  const shouldRender =
    ((canEdit && displayCreateAnnotation === true) || isSavedFromSession) && onCreateAnnotation

  return (
    <div
      onTouchStart={stopPropagation}
      onTouchEnd={stopPropagation}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
    >
      <div className="AnnotationToolbar">
        {displayAuthorName && (
          <div role="tooltip" className="AnnotationTooltip">
            {authorName}
          </div>
        )}
        {(canEdit || canDelete) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              boxSizing: 'border-box',
            }}
          >
            {shouldRender && (
              <button
                className="Annotation-button inst-button--flat"
                aria-label={formatMessage('create annotation')}
                onClick={handleAnnotationSave}
              >
                <CheckSVG />
              </button>
            )}
            <button
              className="Annotation-button inst-button--flat Delete-annotation-button"
              aria-label={formatMessage('delete annotation')}
              onClick={handleAnnotationDelete}
            >
              <DeleteSVG color={'white'} />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
